import React from 'react'
import { useModalDialog } from './useModalDialog'
import { useMessage } from './useMessage'
import { downloadIcs } from '../helpers/ics'

// "Vill du lägga till detta i din kalender?" → .ics download.
//
// One place for the whole sequence, because the ordering inside it is fragile and was
// previously a comment in a single component that a second caller would have had to
// rediscover. Callers pass a payload built by their app's own adapter
// (apps/events/helpers/ics.js, apps/recruitment/helpers/ics.js) and get three lines.
//
// Offered after *marking* interest / signing up, never after cancelling — that check belongs
// to the caller, which is the only side that knows which way its toggle just went.
export const useAddToCalendar = () => {
  const { showModalDialog, hideModalDialog } = useModalDialog()
  const { showMessage } = useMessage()

  const offerAddToCalendar = (appointment) => {
    showModalDialog({
      title: 'Lägg till i kalender',
      Content: () => <div>Vill du lägga till <strong>{appointment.title}</strong> i din kalender som en .ics-fil?</div>,
      submitLabel: 'Ladda ner .ics',
      cancelLabel: 'Nej tack',
      // useModalDialog never auto-closes on success (repo-wide), so hiding is our job
      // regardless — but here the order is not a matter of taste. Close the modal *before*
      // downloading, then defer the download to the next tick. AriaModal's focus trap
      // installs a document-level, capture-phase click listener that calls preventDefault()
      // on any click targeting an element outside the modal's own DOM subtree — the
      // temporary <a> downloadIcs appends to document.body is a sibling of the modal, so
      // while the modal is still mounted the trap silently cancels the synthetic click's
      // default action (the download) before it can start. Once the modal unmounts that
      // listener is removed, so waiting a tick lets the download actually fire.
      onSubmit: () => {
        hideModalDialog()
        setTimeout(() => {
          try {
            const filename = downloadIcs(appointment)
            showMessage(`${filename} laddades ner till din nedladdningsmapp`)
          } catch (err) {
            console.error('Failed to build/download .ics file', err)
            showMessage('Kunde inte skapa .ics-filen', 'error')
          }
        }, 0)
      },
    })
  }

  return { offerAddToCalendar }
}
